import persistentStorage from '$lib/persistentStorage';
import type { CompetitionNotification, Notification } from '$lib/types/notifications';
import { writable, derived, type Writable } from 'svelte/store';

export const notifications: Writable<Record<string, Notification>> = writable({});
export const closedWrapped2023: Writable<boolean> = persistentStorage<boolean>(
	'closed-wrapped-2023',
	false
);
